import { View } from "@/components/ui";
import { Typography } from "@/components/shared/typography";
import { CreditAccountInfo } from "../CreditAccountInfo";
import { CreditOverviewCard } from "../CreditOverviewCard";
import { GeneralCreditOverviewCard } from "../GeneralCreditOverviewCard";
import { IconButton } from "@/components/ui/icon-button";
import { useRoute } from "@/components/shared/router";
import { CreditAccountBanner } from "../CreditAccountBanner";
import type { CreditAccountOverviewProps } from "./CreditAccountOverview.container";
import { AccountMyReferralBanner } from "../../account-my-referral/account-my-referral-banner";

export const CreditAccountOverviewScreen = ({
  overviewBalance,
  generalBalance,
  creditAccounts,
}: CreditAccountOverviewProps) => {
  const { pull } = useRoute();

  return (
    <View className="flex flex-1 flex-col">
      <View className="flex flex-row items-center gap-2 p-3 md:mb-4 md:border-b md:border-secondary-border md:pb-4">
        <IconButton
          iconName="arrowLeft"
          variant="secondary"
          rounded="full"
          color="foreground"
          className="w-[48px]"
          onClick={pull}
        />
        <Typography variant="label-md">Account Credit</Typography>
      </View>
      <View className="flex flex-col gap-4">
        <CreditAccountBanner balance={overviewBalance} icon="overview" />
        <View className="flex flex-col gap-4 px-4 md:px-0">
          <GeneralCreditOverviewCard balance={generalBalance} />
          <CreditAccountInfo type="general" />
          <View className="grid grid-cols-2 gap-1 md:grid-cols-3 md:gap-2">
            {creditAccounts.map((card) => (
              <CreditOverviewCard
                key={card.type}
                type={card.type}
                balance={card.balance}
              />
            ))}
          </View>
          <AccountMyReferralBanner />
        </View>
      </View>
    </View>
  );
};
